'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*-----------------------
Offset
---
Get the offset of an element on the page relative to the document.
-----------------------*/

function offset(el) {
  var rect = el.getBoundingClientRect(),
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, bottom: rect.bottom + scrollTop };
}

/*-------------------------------
Check Nav Sections
---
On pages that have a sticky horizontal scrolling nav, check the nav sections as we
scroll past them to activate the appropriate menu item.
-------------------------------*/

document.addEventListener('DOMContentLoaded', function (event) {
  var navSections = document.querySelectorAll('.section-checker__section');

  // Check which section we are currently on and update the corresponding navigation item

  function checkNavSections() {
    [].concat((0, _toConsumableArray3.default)(navSections)).forEach(function (section) {
      // Calculate the positioning of the section

      var topPosition = offset(section).top;
      var bottomPosition = offset(section).bottom;

      // Find the sections corresponding link

      var sectionName = section.getAttribute('id');
      var sectionNavLink = document.querySelector('.section-checker__nav a[href="#' + sectionName + '"]');

      // If scroll position is within the current section then indicate it in the navigation

      var scrollBelowSectionTop = window.scrollY >= topPosition - 200;
      var scrollAboveSectionBottom = window.scrollY < bottomPosition - 200;

      if (scrollBelowSectionTop && scrollAboveSectionBottom) {
        sectionNavLink.classList.add('active');
      } else {
        sectionNavLink.classList.remove('active');
      }
    });
  }

  if (navSections.length > 0) {
    window.addEventListener('scroll', (0, _debounce2.default)(checkNavSections, 20));
  }
});